import { ApplicationStage, countCompletedSteps } from './ApplicationStage';
import { ApplicationStep } from './ApplicationStep';
import {
  TApplicationStage,
  TApplicationSubStageObject,
} from '../../../Customers.types';
import { SUB_STAGE_NAME_MAP } from '../CustomerInformationModal';

export const BusinessDetailsStage = ({
  currentStage,
  applicationSubStages,
}: {
  currentStage: TApplicationStage['value'];
  applicationSubStages: TApplicationSubStageObject;
}) => {
  const numCompletedSteps = countCompletedSteps(applicationSubStages, [
    'business_type',
    'business_info',
    'director_info',
  ]);
  return (
    <ApplicationStage stage="business_details" currentStage={currentStage}>
      <>
        <div className="mt-[-4px] w-[4px] justify-self-center bg-primary-20"></div>
        <div className="text-m">
          <div className="font-reg">
            The customer has entered their email address and created an account
            to checkout. They now need to fill in all their business details.
          </div>
          <div className="mt-xl font-med">
            {numCompletedSteps}/3 steps completed
          </div>
        </div>
      </>
      <>
        <ApplicationStep
          stepText={SUB_STAGE_NAME_MAP.business_type}
          isComplete={applicationSubStages.business_type.completed}
        />
      </>
      <>
        <ApplicationStep
          stepText={SUB_STAGE_NAME_MAP.business_info}
          isComplete={applicationSubStages.business_info.completed}
        />
      </>
      <>
        <ApplicationStep
          stepText={SUB_STAGE_NAME_MAP.director_info}
          isComplete={applicationSubStages.director_info.completed}
        />
      </>
      <>
        <div className="h mt-[-12px] w-[4px] justify-self-center bg-structure-80 pb-xl"></div>
        <div />
      </>
    </ApplicationStage>
  );
};
